import styled from "styled-components";
import {introduction} from "../../../utils/const/threatGuardConsts";
import FormToGenerateReport from "./FormToGenerateReport";
import {Header} from "../IntReports/IntReports";
import PopupMessage from "./PopupMessage";
import ModalContext from "../demoPointEnv/envResultsTable/ModalContext";
import { useContext } from "react";
import BasicModal from "../demoPointEnv/BasicModal";

const Intro = styled.div`
  font-size: 16px;
`;

const LearnMore = styled.a`
  font-size: 16px;
  color: var(--color-brand-pink-primary);
`;

const ThreatGuard = () => {
    const { threatGuardModalIsOpen, basicModalIsOpen } = useContext(ModalContext);
    return (
        <div>
            <Header>ThreatGuard Lookalike Report</Header>
            <Intro>{introduction[0]}</Intro>
            <Intro>
                <LearnMore id="learnMoreButton" href="https://downloads.checkpoint.com/dc/download.htm?ID=94483"
                           target="threatGuardLink">
                    Learn more
                </LearnMore>
                {introduction[1]}
            </Intro>
            <FormToGenerateReport/>
            {threatGuardModalIsOpen && <PopupMessage/>}
            {basicModalIsOpen && <BasicModal id={"basic_modal"}/>}
        </div>
    );
}

export default ThreatGuard;
